import { render, staticRenderFns } from "./SuggestionBox.vue?vue&type=template&id=60b89cd2&"
import script from "./SuggestionBox.vue?vue&type=script&lang=js&"
export * from "./SuggestionBox.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports